export default __webpack_public_path__ + "static/media/upload.3bb0091f.svg";